import { render, staticRenderFns } from "./Cerete.vue?vue&type=template&id=c85394a4"
import script from "./Cerete.vue?vue&type=script&lang=js"
export * from "./Cerete.vue?vue&type=script&lang=js"
import style0 from "./Cerete.vue?vue&type=style&index=0&id=c85394a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports